import { render, staticRenderFns } from "./SGPFormAnoComponent.vue?vue&type=template&id=52cb03df"
import script from "./SGPFormAnoComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormAnoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports